// extracted by mini-css-extract-plugin
export default {"root":"classes_root__i+wv-","form":"classes_form__6GCl9","funds-origin":"classes_funds-origin__J4Rl2"};